import axios from '@ali/lzdmod-axios';
import Env from './env';

const MOCK_URLS = {
  '/helpcenter/chat/get-oss-policy': '/test/mockData/oss.json',
  '/seller/helpcenter/chat/get-oss-policy': '/test/mockData/oss.json',
  '/helpcenter/chat/get-orders/': '/test/mockData/get-orders.json',
};

const getDomain = () => {
  const venture = Env.venture.toLowerCase();
  const isSeller = window.g_config.cscClient === 'seller';
  const staging = isSeller ? 'sellercenter-staging' : 'helpcenter-pre';
  const live = isSeller ? 'sellercenter' : 'www';
  const domainEnv = Env.env === 'live' ? live : staging;
  let domain = '';
  switch (venture) {
    case 'sg':
    case 'vn':
      domain = `https://${domainEnv}.lazada.${venture}`;
      break;
    case 'my':
    case 'ph':
      domain = `//${domainEnv}.lazada.com.${venture}`;
      break;
    case 'id':
    case 'th':
      domain = `//${domainEnv}.lazada.co.${venture}`;
      break;

    case 'lk':
    case 'pk':
      domain = `//${domainEnv}.daraz.${venture}`;
      break;
    case 'bd':
    case 'np':
      domain = `//${domainEnv}.daraz.com.${venture}`;
      break;
    case 'mm':
      domain = `//${domainEnv}.shop.com.${venture}`;
      break;
    default:
      domain = '';
  }
  return domain;
};

const request = (params) => {
  let url = '';
  const urlParams = params.path.split('?')[1] || '';
  const path = urlParams ? params.path.split(urlParams)[0] : params.path;

  switch (Env.env) {
    case 'pre':
    case 'live':
      url = getDomain() + params.path;
      break;
    case 'dev':
    default:
      url = `${MOCK_URLS[path.replace(/\?$/, '')]}?${urlParams}`;
      break;
  }

  return axios({
    url,
    method: params.method || 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    withCredentials: true,
    data: null,
  });
};

const getOSSData = () => {
  if (window.g_config.cscClient === 'seller') {
    return request({
      path: '/seller/helpcenter/chat/get-oss-policy',
    });
  }
  return request({
    path: '/helpcenter/chat/get-oss-policy',
  });
};

const getOrderList = () => (request({
  path: '/helpcenter/chat/get-orders/',
}));

export default request;
export { getOSSData, getOrderList };



// WEBPACK FOOTER //
// ./src/utils/request.js